export const GCLID_STORAGE_KEY = 'gclid'
